import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vultr = defineConnector({
  identifier: "vultr",
  name: "Vultr",
  tagLine: "Cloud compute, bare metal, and storage",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.vultr\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Vultr API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Vultr customer portal](https://my.vultr.com/settings/#settingsapi), go to **Account > API** and copy your API key. Make sure the API is enabled and your IP is allowed.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.vultr.com/v2/account",
  },
});
